import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token.service';

@Injectable({
  providedIn: 'root'
})
export class AgentauthGuard implements CanActivate {
  constructor(private router: Router, private tokenService: TokenService) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

 
    const token = sessionStorage.getItem('loginToken');
    const isAuthenticated = !!sessionStorage.getItem('loginToken'); // or use real auth service
    //  const isLocked = sessionStorage.getItem('isLocked') === 'true';
    // const token = localStorage.getItem('token');
    if (token && this.tokenService.isTokenExpired(token)) {
      this.router.navigate(['/']);
      return false;
    }

    if (!isAuthenticated) {
      this.router.navigate(['/']);
      return false;
    }

    // if (isLocked) {
    //   this.router.navigate(['/lock-screen']);
    //   return false;
    // }
    return true;

  }

}
